import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import { createApolloProvider } from "./createApolloProvider"
import { router } from "./router"

import VueNumeric from 'vue-numeric'
Vue.use(VueNumeric)

import { library } from '@fortawesome/fontawesome-svg-core';
// internal icons
import { faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
    faArrowUp, faAngleRight, faAngleLeft, faAngleDown, faExternalLinkAlt,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload, faFileCsv, faFile
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
    faArrowUp, faAngleRight, faAngleLeft, faAngleDown, faExternalLinkAlt,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload, faFileCsv, faFile);
Vue.component('vue-fontawesome', FontAwesomeIcon);    

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
})

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import moment from 'moment'

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatEnumLabel', function(enumName) {
  if (enumName.length === 1) return enumName;
  return enumName
    .split("_")
    .map(n => {
      if (n.length > 2) {
        return n.charAt(0).toUpperCase() + n.slice(1).toLowerCase();
      } else {
        return n.toLowerCase();
      }
    })
    .join(" ");
})

import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
 
// load a locale
numeral.register('locale', 'br', {
  delimiters: {
      thousands: '.',
      decimal: ','
  },
  abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
  },
  ordinal : function (number) {
      return number === 1 ? 'ro' : 'ra';
  },
  currency: {
      symbol: 'R$'
  }
});

// switch between locales
numeral.locale('br');

Vue.filter('numFormat', numFormat(numeral));

import VueBlobJsonCsv from 'vue-blob-json-csv';

Vue.use(VueBlobJsonCsv)

//Cria instância Vue
new Vue({
  router,
  apolloProvider: createApolloProvider(),
  render: h => h(App)
}).$mount('#app')
